/*
 * SideBar Messages
 *
 * This contains all the text for the SideBar component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'components.SideBar';

export default defineMessages({
  space: {
    id: `${scope}.space`,
    defaultMessage: 'Space',
  },
  account: {
    id: `${scope}.account`,
    defaultMessage: 'Account',
  },
  questionnaires: {
    id: `${scope}.questionnaires`,
    defaultMessage: 'Questionnaires',
  },
  spaces: {
    id: `${scope}.spaces`,
    defaultMessage: 'Spaces',
  },
  profile: {
    id: `${scope}.profile`,
    defaultMessage: 'Profile',
  },
  testResults: {
    id: `${scope}.testResults`,
    defaultMessage: 'Test Results',
  },
  testResultsImported: {
    id: `${scope}.testResultsImported`,
    defaultMessage: 'Imported Test Results',
  },
  users: {
    id: `${scope}.users`,
    defaultMessage: 'Users',
  },
  members: {
    id: `${scope}.members`,
    defaultMessage: 'Members',
  },
  groups: {
    id: `${scope}.groups`,
    defaultMessage: 'Groups',
  },
  settings: {
    id: `${scope}.settings`,
    defaultMessage: 'Settings',
  },
  home: {
    id: `${scope}.home`,
    defaultMessage: 'Home',
  },
  qualifications: {
    id: `${scope}.qualifications`,
    defaultMessage: 'Qualifications',
  },
  achievements: {
    id: `${scope}.achievements`,
    defaultMessage: 'Achievements',
  },
  helpPage: {
    id: `${scope}.helpPage`,
    defaultMessage: 'Help Page',
  },
  support: {
    id: `${scope}.support`,
    defaultMessage: 'Support',
  },
  logout: {
    id: `${scope}.logout`,
    defaultMessage: 'Log Out',
  },
  testType: {
    id: `${scope}.testType`,
    defaultMessage: 'Test Groups',
  },
  worldRecords: {
    id: `${scope}.worldRecords`,
    defaultMessage: 'World Records',
  },
});
